<template>
  <div class="row">
    <div class="col-12 col-md-12">
		<card class="responsive-card-table">
    	<h2 slot="header" class="card-title">Gestione utenti</h2>
      <users-table />
		</card>
    </div>
  </div>
</template>
<script>
import UsersTable from '@/components/UsersTable';

export default {
  components: {
    UsersTable
  }
};
</script>
<style></style>
